import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/artist/$id/_artist/profile_/_profile/')({
  beforeLoad: ({ context }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/'
      });
    }
  }
});
